import React, { useEffect, useRef, useState } from 'react';
import { Formik, Form } from 'formik';
import { useParams, useNavigate } from 'react-router-dom';
import Select from '~components/Form/components/Select';
import InputField from '~components/Form/components/InputField';
import NavTabs from '~components/NavTabs';
import { useConfigureFooter } from '~hooks/useHelpers';
import { initialPath } from '~misc/paths';
import { db } from '~db/db';
import useFunilObraGrupoProduto from '~fetchs/useFunilObraGrupoProduto';
import useFunilObraUnidadeMedida from '~fetchs/Funnel/useFunilObraUnidadeMedida';
import { useFunnelNewGroupSchema } from '../hooks/useFunnelNewGroupSchema';
import originControl from '~services/utils/originControl';

const FunnelNewGroup = () => {
  useConfigureFooter({ form: true, formId: 'novo', submitLabel: 'Mapear', disabled: false });

  const formikRef = useRef();
  const navigate = useNavigate();
  const { parameter: id_cliente } = useParams();
  const clienteId = parseInt(id_cliente) ?? 0;
  const { origens } = originControl();
  const url = globalThis.location.pathname;

  const [selectedFunnelGroups, setSelectedFunnelGroups] = useState({});

  const { optionFunilObraGruposProduto, onChangeFunilObraGrupoProduto, funilObraGrupoProdutoSelect, funilObraGrupoProduto } = useFunilObraGrupoProduto({ formikRef })
  const { optionFunilObraUnidadeMedida, onChangeFunilObraUnidadeMedida, funilObraUnidadeMedidaSelect } = useFunilObraUnidadeMedida({ 
    formikRef, 
    funilObraGrupoProdutoId: funilObraGrupoProduto, 
    showAllOptions: false 
  })

  const getFunnelData = async () => {
    let temp = [];
    await db.funilObraNaoSalvo.where({ clienteId: clienteId }).each(e => temp.push(e));

    return temp;
  }

  const handleSubmit = async (values) => {
    await db.funilObraNaoSalvo.add({
      ...values,
      clienteId
    });
    navigate(`${initialPath}/funil-de-obras/${clienteId}/mapeamento?origem=${origens.mapeamento}`,{ state: { skipRedirect: true }});
  }

  useEffect(() => {
    (async() => {
      const funnel = await getFunnelData();
      setSelectedFunnelGroups(funnel.reduce((acc, cur) => {
        acc[cur.funilObraGrupoProdutoId] = true;
        return acc;
      }, {}));
    })()
  }, []);

  return (
    <section className="container">
      <NavTabs navs={[{
        name: 'Funil de Obras',
        link: url,
      }]} customClasses={'!flex-none !w-[40%]'} />

      <Formik
        initialValues={{
          funilObraGrupoProdutoId: 0,
          dataNegociacao: "",
          funilObraUnidadeMedidaId: 0,
          volumeMapeado: 0,
          volumeNegociado: 0,
        }}
        validateOnBlur={true}
        validationSchema={useFunnelNewGroupSchema()}
        enableReinitialize
        innerRef={formikRef}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
      >
        {({setFieldValue, errors, touched}) => (
          <Form id="novo">
            <div className="relative containerForm mt-4 rounded-xl bg-white p-7">

              <div className="sm:flex justify-between py-3">
                <h2 className="text-2xl font-bold title pb-6">
                  Dados Gerais
                </h2>
              </div>

              <div className="grid grid-cols-2 gap-4">
                  <Select
                    options={optionFunilObraGruposProduto?.filter(g => !selectedFunnelGroups[g.value])}
                    label="Grupo Produto:"
                    name="funilObraGrupoProdutoId"
                    placeholder="Grupo Produto"
                    spacingControl={true}
                    onChange={(e) => onChangeFunilObraGrupoProduto(e)}
                    errors={errors.funilObraGrupoProdutoId}
                    touched={touched.funilObraGrupoProdutoId}
                    {...funilObraGrupoProdutoSelect}
                  />

                  <InputField
                    labelName="Data de Negociação:"
                    inputName="dataNegociacao"
                    inputMask="offmask"
                    inputType="month"
                    isRequired
                    onChangeEvent={(e) => {
                      setFieldValue("dataNegociacao", e.target.value)
                    }}
                  />
                  
                  <Select
                    options={optionFunilObraUnidadeMedida}
                    label="Unidade de Medida:"
                    name="funilObraUnidadeMedidaId"
                    placeholder="Unidade de Medida"
                    spacingControl={true}
                    onChange={(e) => onChangeFunilObraUnidadeMedida(e)}
                    errors={errors.funilObraUnidadeMedidaId}
                    touched={touched.funilObraUnidadeMedidaId}
                    {...funilObraUnidadeMedidaSelect}
                  />

                  <div className="flex gap-x-2">

                    <InputField
                      labelName="Volume Mapeado:"
                      tooltip="Volume total estimado para obra"
                      inputName="volumeMapeado"
                      inputMask="offmask"
                      inputType="number"
                      placeholder="Volume Mapeado"
                      onWheel={(e) => e.target.blur()}
                      onChangeEvent={(e) => {
                        setFieldValue("volumeMapeado", parseInt(e.target.value ?? 0))
                      }}
                    />

                    <InputField
                      labelName="Volume Negociado:"
                      tooltip="Volume em negociação"
                      inputName="volumeNegociado"
                      inputMask="offmask"
                      inputType="number"
                      placeholder="Volume Negociado"
                      onWheel={(e) => e.target.blur()}
                      onChangeEvent={(e) => {
                        setFieldValue("volumeNegociado", parseInt(e.target.value ?? 0))
                      }}
                    />
                  </div>
                </div>
            </div>
          </Form>
        )}
      </Formik>
    </section>
  );
};

export default FunnelNewGroup;
